// import { SubmitHandler } from 'react-hook-form';
import { IContentsContentElem } from 'app-template-lib/utils';
import { TContentsContentParams } from '../../../../shared/t-contents-params';
import { useState } from 'react';

//ShadCNコンポーネント
import {
    Button,
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue,
} from 'app-template-lib/components/shadcn';

//コンテンツ
import { SeisakuCards } from '../shared/organisms/card/seisakusCard.presenter';
import { DivisionCards } from '../shared/organisms/card/divisionCard.presenter';
import { BarChartWidget } from './../shared/organisms/chart/barChartWidget.presenter';
import { KeikakuIntroCard } from '../shared/organisms/card/keikakuCard.presenter';
import { useHistory, useParams } from 'react-router-dom';
import { FETCH_M_SOSHIKI_DIVISIONS } from '../../queries/pdca_m_soshiki_division.queries.type';
import { useToppagePresenter } from './toppage.presenter.hooks';
import { TrendingUp, TrendingDown, ChevronUp, ChevronDown } from 'lucide-react';
import { ToWarekiFormatter } from '../../utils/toWarekiFormatter';

import { Saishutsu, Sainyu } from '../top/toppage.container.hooks';

interface ITopPagePresenterProps<U> extends IContentsContentElem<U> {
    data: FETCH_M_SOSHIKI_DIVISIONS | undefined;
    saishutsus: Saishutsu[];
    sainyus: Sainyu[];
    lgconfig: { id: string; lgcode: string; created_year: number } | undefined;
}

type JIGYOHIS = {
    SaishutsuYosan: number | undefined;
    jigyohiRate: number | undefined;
    floatRate: number | undefined;
    Sainyu: number | undefined;
    SaishutsuKessan: number | undefined;
    length?: number;
};

/**
 * TOPページプレゼンターコンポーネント
 * @param param0
 * @returns
 */
export function Top({ data, saishutsus, sainyus, lgconfig }: ITopPagePresenterProps<TContentsContentParams>) {
    const history = useHistory();
    const { lgcode, jigyoYear } = useParams<{ lgcode: string; jigyoYear: string }>();
    const { soshikiDivisions, seisakuShisakus, dashBoardDatas } = useToppagePresenter(data);
    const [showAll, setShowAll] = useState(false);
    const [jigyoYearSelect, setJigyoYearSelect] = useState(jigyoYear);
    const selectable = [2026, 2025, 2024];
    const MAX_INITIAL_ROWS = 12; // 歳入 初期表示する行数

    const jigyoPhase: string = lgconfig && Number(lgconfig.created_year) > Number(jigyoYear) ? 'kessan' : 'yosan';

    let jigyohis: JIGYOHIS = {
        SaishutsuYosan: undefined,
        jigyohiRate: undefined,
        floatRate: undefined,
        Sainyu: undefined,
        SaishutsuKessan: undefined,
    };

    // 事業費　データ件数を制限して取得（歳入）
    const visibleRows = showAll ? sainyus : sainyus.slice(0, MAX_INITIAL_ROWS);

    //dashboard事業費データ設定
    if (dashBoardDatas !== null) {
        const currentYear = Number(jigyoYear);

        const sorted = [...dashBoardDatas.yosanDatas].sort((a, b) => a.jigyo_year - b.jigyo_year);

        const currentIndex = sorted.findIndex((y) => y.jigyo_year === currentYear);

        if (currentIndex !== -1) {
            const current = sorted[currentIndex];
            const previous = sorted[currentIndex - 1];

            let jigyohiRate: number | undefined = undefined;
            let floatRate: number | undefined = undefined;

            // 決算フェーズは歳出決算額、予算フェーズは歳出予算額で前年度と比較
            const saishutsuKey = jigyoPhase === 'kessan' ? 'saishutsuKessan' : 'saishutsuYosan';

            if (previous && previous[saishutsuKey] !== 0) {
                jigyohiRate = current[saishutsuKey] - previous[saishutsuKey];

                floatRate = (jigyohiRate / previous[saishutsuKey]) * 100;
            }

            jigyohis = {
                SaishutsuYosan: current.saishutsuYosan,
                SaishutsuKessan: current.saishutsuKessan,
                Sainyu: current.sainyu,
                jigyohiRate,
                floatRate,
            };
        }
    }

    // 予算額を「万円」「億円」表示にフォーマット
    const formatYosan = (value: number) => {
        const oku = Math.floor(value / 100000000); // 億の部分
        const man = Math.floor((value % 100000000) / 10000); // 万の部分
        const yen = value % 10000; // 余り（万円未満）

        let result = '';
        if (oku > 0) result += oku.toLocaleString() + '億';
        if (man > 0) result += man.toLocaleString() + '万';
        if (yen > 0) result += yen + '円';

        return result;
    };

    return (
        <div>
            <section className="py-2 px-2">
                <Select
                    onValueChange={(value) => {
                        setJigyoYearSelect(value);
                        history.push({ pathname: `/toppage/${lgcode}/${value}` });
                    }}
                    defaultValue={String(jigyoYear)}
                >
                    <SelectTrigger className="w-[180px]  bg-white">
                        <SelectValue placeholder="年度を選択" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectGroup>
                            {selectable.map((year) => (
                                <SelectItem key={year} value={String(year)}>
                                    {ToWarekiFormatter(year)}
                                </SelectItem>
                            ))}
                        </SelectGroup>
                    </SelectContent>
                </Select>
            </section>
            {/* 計画紹介欄 */}

            <section id="chart" className="container mx-auto  grid grid-cols-1 md:grid-cols-[4fr_6fr] gap-1 mt-3 px-2 ">
                <div>
                    <Card className="mb-2">
                        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-1 pt-3">
                            <CardTitle className="text-sm font-medium">
                                {jigyoPhase === 'kessan' ? '一般会計　歳出決算額' : '一般会計　歳出当初予算額'}
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="pb-4">
                            <div className="text-2xl font-bold">
                                {jigyohis.SaishutsuKessan && jigyoPhase === 'kessan'
                                    ? formatYosan(jigyohis.SaishutsuKessan)
                                    : jigyohis.SaishutsuYosan
                                    ? formatYosan(jigyohis.SaishutsuYosan)
                                    : ''}
                                円
                            </div>
                        </CardContent>
                    </Card>
                    <Card className="mb-2">
                        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-1 pt-3">
                            <CardTitle className="text-sm font-medium">
                                {jigyoPhase === 'kessan' ? '一般会計　歳入決算額' : '一般会計　歳入当初予算額'}
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="pb-4">
                            <div className="text-2xl font-bold">{jigyohis.Sainyu && formatYosan(jigyohis.Sainyu)}円</div>
                        </CardContent>
                    </Card>
                    <Card className="mb-2">
                        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-1 pt-3">
                            <CardTitle className="text-sm font-medium">歳出 対前年度</CardTitle>
                        </CardHeader>
                        <CardContent className="pb-4">
                            <div className="text-2xl font-bold flex">{jigyohis.jigyohiRate && formatYosan(jigyohis.jigyohiRate)}円</div>
                            <p className="text-xs text-muted-foreground min-h-1">
                                <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    {jigyohis.floatRate && jigyohis.floatRate > 0 ? (
                                        <div style={{ color: 'red', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <TrendingUp size={16} />
                                            {jigyohis.floatRate.toFixed(1)}%
                                        </div>
                                    ) : (
                                        <div style={{ color: 'blue', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <TrendingDown size={16} />
                                            {jigyohis.floatRate && jigyohis.floatRate.toFixed(1)}%
                                        </div>
                                    )}
                                </span>
                            </p>
                        </CardContent>
                    </Card>
                    <Card className="mb-2 md:mb-0">
                        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-1 pt-3">
                            <CardTitle className="text-sm font-medium">事業数</CardTitle>
                        </CardHeader>
                        <CardContent className="pb-4">
                            <div className="text-2xl font-bold">{dashBoardDatas?.jigyoCount}事業</div>
                            <p className="text-xs text-muted-foreground min-h-1"></p>
                        </CardContent>
                    </Card>
                </div>

                <BarChartWidget dashBoardDatas={dashBoardDatas} lgconfig={lgconfig} jigyoYear={jigyoYear} />
            </section>

            <section id="tabs" className=" px-2">
                <Tabs defaultValue="output" className="w-full py-4">
                    <TabsList className="w-full">
                        <TabsTrigger
                            value="output"
                            className="w-1/2 bg-secondary data-[state=active]:bg-primary data-[state=active]:text-white"
                        >
                            一般会計　歳出
                        </TabsTrigger>
                        <TabsTrigger
                            value="income"
                            className="w-1/2 bg-secondary data-[state=active]:bg-primary data-[state=active]:text-white border"
                        >
                            一般会計　歳入
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value="output">
                        <Card>
                            <CardHeader>
                                <CardTitle>主な歳出</CardTitle>
                                <CardDescription>自治体の1年間の支出のこと</CardDescription>
                            </CardHeader>
                            <CardContent className="space-y-2">
                                <Table>
                                    <TableHeader>
                                        <TableRow>
                                            <TableHead className="w-[100px]" colSpan={8}>
                                                区分
                                            </TableHead>
                                            {/* <TableHead>Status</TableHead> */}
                                            {/* <TableHead className="text-right">比較増減</TableHead> */}
                                            <TableHead className="text-right">
                                                {jigyoPhase === 'kessan' ? '決算額（千円）' : '予算額（千円）'}
                                            </TableHead>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {saishutsus.map((saishutsu) => (
                                            <TableRow key={saishutsu.saishutsu_name}>
                                                <TableCell className="font-medium" colSpan={8}>
                                                    {saishutsu.saishutsu_name}
                                                </TableCell>
                                                {/* <TableCell className="text-right">{saishutsu.paymentStatus}</TableCell> */}
                                                <TableCell className="text-right">{saishutsu.totalAmount.toLocaleString()}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </CardContent>
                        </Card>
                    </TabsContent>
                    <TabsContent value="income">
                        <Card>
                            <CardHeader>
                                <CardTitle>主な歳入</CardTitle>
                                <CardDescription>自治体の1年間の収入のこと</CardDescription>
                            </CardHeader>
                            <CardContent className="space-y-1">
                                <Table>
                                    <TableHeader>
                                        <TableRow>
                                            <TableHead colSpan={8}>区分</TableHead>
                                            {/* <TableHead className="text-right">比較増減</TableHead> */}
                                            <TableHead className="text-right">
                                                {' '}
                                                {jigyoPhase === 'kessan' ? '決算額（千円）' : '予算額（千円）'}
                                            </TableHead>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>
                                        {visibleRows.map((sainyu) => (
                                            <TableRow key={sainyu.sainyu_name}>
                                                <TableCell className="font-medium" colSpan={8}>
                                                    {sainyu.sainyu_name}
                                                </TableCell>
                                                {/* <TableCell className="text-right">{sainyu.paymentStatus}</TableCell> */}
                                                <TableCell className="text-right">{sainyu.totalAmount.toLocaleString()}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                {sainyus.length > MAX_INITIAL_ROWS && (
                                    <div className="text-center mt-2">
                                        <Button variant="ghost" className="bg-gray-100" size="sm" onClick={() => setShowAll(!showAll)}>
                                            {showAll ? (
                                                <>
                                                    <ChevronUp className="mr-1" />
                                                    閉じる
                                                </>
                                            ) : (
                                                <>
                                                    <ChevronDown className="mr-1" />
                                                    すべて表示
                                                </>
                                            )}
                                        </Button>
                                    </div>
                                )}
                            </CardContent>
                        </Card>
                    </TabsContent>
                </Tabs>
            </section>

            {/* 計画紹介欄 */}
            <section id="keikaku" className="bg-[#EFF4F7] rounded-md">
                <KeikakuIntroCard lgcode={lgcode} jigyoYear={jigyoYear} />
            </section>

            {/* 政策一覧 */}
            <section>
                <SeisakuCards
                    seisakuShisakus={seisakuShisakus}
                    onClickSeisakuButton={(seisakuId) => {
                        history.push({ pathname: `/list/${lgcode}/${jigyoYear}`, state: { seisakuId, divisionId: null } });
                    }}
                />
            </section>

            {/* 組織一覧 */}
            <section>
                <DivisionCards
                    soshikiDivisions={soshikiDivisions}
                    onClickDivisionButton={(divisionId) => {
                        history.push({ pathname: `/list/${lgcode}/${jigyoYear}`, state: { divisionId, seisakuId: null } });
                    }}
                />
            </section>

            {/* 全ての事業一覧ボタン */}
            <section className="flex justify-center pb-10">
                <Button
                    className="w-[95%] md:w-1/2"
                    onClick={() => history.push({ pathname: `/list/${lgcode}/${jigyoYear}`, state: { divisionId: null, seisakuId: null } })}
                >
                    全ての事業一覧
                </Button>
            </section>
        </div>
    );
}
